// src/components/common/LoadingSpinner.jsx
import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = ({ mensaje = "Cargando..." }) => {
  return (
    <div className="loading-spinner" role="status" aria-live="polite">
      <span className="loading-spinner-ring" aria-hidden="true" />
      <p className="loading-spinner-text">{mensaje}</p>
    </div>
  );
};

export default LoadingSpinner;